// Module
var code = "<branch-values kind=\"'currencies'\"></branch-values>\n";
// Exports
module.exports = code;